// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "37d87fe756ab8f5dc7e9079bab0ca6d0418556c3/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};